<template>
  <div id="event">
    <el-row class="warp">
      <el-col :span="24" class="warp-breadcrum">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }"
            ><b>首页</b></el-breadcrumb-item
          >
          <el-breadcrumb-item>监控追溯</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
      <el-col> </el-col>
    </el-row>
    <el-row>
      <el-col
        :span="24"
        class="warp-main"
        v-loading="loading"
        element-loading-text="拼命加载中"
      >
        <!--工具条-->
        <el-col :span="24" class="toolbar" style="padding-bottom: 0px">
          <el-form :inline="true" :model="searchForm">
            <el-form-item label="事件类别:">
              <el-select
                v-model="searchForm.eventTypeId"
                placeholder="事件类别"
                style="width: 350px"
              >
                <el-option
                  v-for="(item, index) in typeSelect"
                  :key="index"
                  :label="item.deviceSupplierName + '-' + item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="设备号：">
              <el-input
                v-model="searchForm.deviceCode"
                placeholder="请输入设备号"
                style="width: 350px"
              ></el-input>
            </el-form-item>
            <el-form-item label="设备短号：">
              <el-input
                v-model="searchForm.deviceShortcode"
                placeholder="请输入设备短号"
                style="width: 350px"
              ></el-input>
            </el-form-item>
            <el-form-item label="项目">
              <el-select
                v-model="searchForm.projectId"
                filterable
                :filter-method="getMyProject"
                placeholder="项目"
                @clear="clearProject"
                @focus="focusProject"
                :change="clearProject"
                clearable
                style="width: 350px"
              >
                <el-option
                  v-for="(item, index) in projectSelects"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="发生时间：">
              <el-date-picker
                v-model="searchForm.date"
                type="daterange"
                range-separator="至"
                start-placeholder="发生时间"
                end-placeholder="发生时间"
                value-format="yyyy-MM-dd HH:mm:ss"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" v-on:click="handleSearch"
                >查询</el-button
              >
            </el-form-item>
          </el-form>
        </el-col>

        <!--列表-->
        <el-table
          :data="devices"
          highlight-current-row
          v-loading="loading"
          border
          style="width: 100%"
        >
          <el-table-column
            type="index"
            label="序号"
            width="50"
            fixed="left"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="deviceCode"
            label="设备号"
            width="200"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="deviceShortcode"
            label="设备短号"
            width="180"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="deviceSn"
            label="型号"
            width="150"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="projectName"
            label="项目"
            width="180"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="happedTime"
            label="发生时间"
            width="180"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="eventTypeParentName"
            label="大类父类"
            width="180"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="eventName"
            label="事件类别"
            width="150"
            align="center"
            style="color: red"
          >
            <template slot-scope="scope">
              <el-tag
                ><font :color="scope.row.colorValue">{{
                  scope.row.eventName
                }}</font></el-tag
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="eventState"
            label="告警状态"
            width="150"
            align="center"
          >
            <template slot-scope="scope">
              <div
                v-if="scope.row.eventState === 0"
                @click="updateState(scope.index, scope.row)"
                style="cursor: pointer"
              >
                <el-tag style="color: red">未解除</el-tag>
              </div>
              <div v-if="scope.row.eventState === 1">
                <el-tag style="color: green">已解除</el-tag>
              </div>
              <div v-if="scope.row.eventState === 2">
                <el-tag style="color: green">正常</el-tag>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="sureState"
            label="确认情况"
            width="150"
            align="center"
          >
            <template slot-scope="scope">
              <el-tag v-if="scope.row.sureState === 0" style="color: red"
                >未确认</el-tag
              >
              <el-tag v-if="scope.row.sureState === 1" style="color: green"
                >已确认</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="noteState"
            label="通知情况"
            width="150"
            align="center"
          >
            <template slot-scope="scope">
              <div
                @click="showNotice(scope.index, scope.row)"
                style="cursor: pointer"
              >
                <el-tag v-if="scope.row.noteState === 0" style="color: red"
                  >未通知</el-tag
                >
                <el-tag v-if="scope.row.noteState === 1" style="color: green"
                  >通知已送达</el-tag
                >
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="noteState"
            label="总队处理状态"
            width="180"
            align="center"
          >
            <template slot-scope="scope">
              <div>
                <el-tag v-if="scope.row.shxfState === 0" style="color: red"
                  >未处理</el-tag
                >
                <el-tag
                  v-else-if="gzEvent.indexOf(scope.row.eventCode) > -1"
                  style="color: green"
                >
                  <span v-if="scope.row.shxfState == 1">误报</span>
                  <span v-if="scope.row.shxfState == 2">已修复</span>
                  <span v-if="scope.row.shxfState == 3">维保</span>
                  <span v-if="scope.row.shxfState == 4">测试</span>
                </el-tag>
                <el-tag
                  v-else-if="
                    bjEvent.indexOf(scope.row.eventCode) > -1 ||
                    scope.row.eventCode == '1'
                  "
                  style="color: green"
                >
                  <span v-if="scope.row.shxfState == 1">误报</span>
                  <span v-if="scope.row.shxfState == 2">真实报警</span>
                  <span v-if="scope.row.shxfState == 3">维保</span>
                  <span v-if="scope.row.shxfState == 4">测试</span>
                </el-tag>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            prop="addressDetail"
            label="地址"
            width="380"
            align="center"
            :formatter="addressFormatter"
          ></el-table-column>
          <el-table-column
            prop="position"
            label="位置"
            width="220"
            align="center"
          ></el-table-column>
          <el-table-column
            label="操作"
            fixed="right"
            align="center"
            width="170"
          >
            <template slot-scope="scope">
              <el-button
                type="primary"
                round
                size="mini"
                @click="showHandle(scope.index, scope.row)"
                style="padding: 8px; margin: 0"
                >处理详情</el-button
              >
              <el-button
                v-if="
                  (gzEvent.indexOf(scope.row.eventCode) > -1 ||
                    bjEvent.indexOf(scope.row.eventCode) > -1 ||
                    scope.row.eventCode == '1') &&
                  scope.row.shxfState == 0
                "
                type="primary"
                round
                size="mini"
                @click="reportHandle(scope.row)"
                style="padding: 8px; margin: 0"
                >总队处理上报</el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <!--分页工具条-->
        <el-col :span="24" class="toolbar">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            background
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            style="float: right"
          >
          </el-pagination>
        </el-col>
      </el-col>
    </el-row>

    <!--处理详情-->
    <el-dialog
      title="处理详情"
      :visible.sync="handle.formVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="handle.data" label-width="160px">
        <el-form-item class="title" label="设备编号：">
          <div class="content">{{ handle.data.deviceCode }}</div>
        </el-form-item>
        <el-form-item class="title" label="设备名称：">
          <div class="content">{{ handle.data.deviceName }}</div>
        </el-form-item>
        <el-form-item class="title" label="告警类型：">
          <div class="content">{{ handle.data.eventName }}</div>
        </el-form-item>
        <el-form-item class="title" label="告警状态：">
          <div class="content">
            {{ handle.data.eventState == 1 ? "已处理" : "未处理" }}
          </div>
        </el-form-item>
        <el-form-item class="title" label="告警时间：">
          <div class="content">{{ handle.data.happenTime }}</div>
        </el-form-item>
        <el-form-item class="title" label="告警值：">
          <div class="content">{{ handle.data.eventValue }}</div>
        </el-form-item>
        <el-form-item class="title" label="项目：">
          <div class="content">{{ handle.data.projectName }}</div>
        </el-form-item>
        <el-form-item class="title" label="地址：">
          <div class="content">
            {{
              handle.data.province +
              handle.data.city +
              handle.data.district +
              handle.data.address
            }}
          </div>
        </el-form-item>
        <el-form-item class="title" label="位置：">
          <div class="content">{{ handle.data.position }}</div>
        </el-form-item>
        <div v-if="handle.data.eventState == 1">
          <el-form-item class="title" label="图片：">
            <div class="content">
              <div class="demo-image">
                <div
                  class="block"
                  v-for="(item, index) in handle.data.images"
                  :key="index"
                >
                  <el-image
                    style="width: 100px; height: 100px"
                    :src="item"
                    fit="cover"
                    :preview-src-list="handle.data.images"
                  ></el-image>
                </div>
              </div>
            </div>
          </el-form-item>
          <el-form-item class="title" label="处理结果：">
            <div class="content">{{ handle.data.handleContent }}</div>
          </el-form-item>
          <el-form-item
            v-if="handle.data.workNo"
            class="title"
            label="工单号："
          >
            <div class="content">{{ handle.data.workNo }}</div>
          </el-form-item>
          <el-form-item class="title" label="处理人：">
            <div class="content">{{ handle.data.handleUser }}</div>
          </el-form-item>
          <el-form-item class="title" label="处理时间：">
            <div class="content">{{ handle.data.handleTime }}</div>
          </el-form-item>
        </div>
      </el-form>
    </el-dialog>

    <!--总队处理上报-->
    <el-dialog
      title="总队处理上报"
      :visible.sync="report.formVisible"
      :close-on-click-modal="false"
    >
      <el-form label-width="130px">
        <el-form-item class="title" label="处理状态：">
          <el-select
            v-if="
              bjEvent.indexOf(report.data.eventCode) > -1 ||
              report.data.eventCode == '1'
            "
            v-model="report.state"
            placeholder="请选择"
          >
            <el-option
              v-for="item in report.bjoptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-select
            v-if="gzEvent.indexOf(report.data.eventCode) > -1"
            v-model="report.state"
            placeholder="请选择"
          >
            <el-option
              v-for="item in report.gzoptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="report.formVisible = false">取消</el-button>
        <el-button type="primary" @click="report.submit()">提交</el-button>
      </div>
    </el-dialog>

    <!--通知列表-->
    <el-dialog
      id="pushList"
      title="通知列表"
      :visible.sync="push.formVisible"
      :close-on-click-modal="false"
      width="96%"
    >
      <!--列表-->
      <el-table
        :data="push.data"
        highlight-current-row
        v-loading="loading"
        border
        style="width: 100%"
        :row-class-name="tableRowClassName"
        >>
        <el-table-column
          type="index"
          label="序号"
          width="50"
          fixed="left"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="safeUserName"
          label="推送人"
          width="200"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="orgName"
          label="单位"
          width="200"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="pushTime"
          label="推送时间"
          width="180"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="isDelete"
          label="状态"
          width="150"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="msgId"
          label="微信消息ID"
          width="180"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="msgStateCode"
          label="状态码"
          width="180"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="msgText"
          label="描述"
          align="center"
          style="color: red"
        ></el-table-column>
        <el-table-column label="操作" width="150" align="center">
          <template slot-scope="scope">
            <div
              v-if="scope.row.isDelete == 0"
              @click="push.rePush(scope.index, scope.row)"
              style="cursor: pointer"
            >
              <el-tag style="color: red">推送</el-tag>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<style>
#event .title {
  font-weight: bold;
  line-height: 0;
  margin-bottom: 12px;
}
#event .title .content {
  color: #bbbbbb;
  font-weight: 100;
}
#event .demo-image .block {
  text-align: center;
  border-right: 1px solid #eff2f6;
  display: inline-block;
  width: 15%;
  box-sizing: border-box;
  vertical-align: top;
}
#event .el-form-item__label {
  line-height: 20px;
}
#event .el-form-item__content {
  line-height: 20px;
}
#pushList tr.delete {
  color: #dcdfe6;
}
</style>
<script>
import EventType_API from "../../api/device/api_deviceEventDictionary";
import Event_API from "../../api/device/api_event";
import PROJECT_API from "../../api/api_project";
export default {
  data() {
    return {
      devices: [],
      gzEvent: ["2", "11", "12", "13", "14"],
      bjEvent: ["8", "15"],
      projectSelects: [],
      loading: false,
      total: 0,
      page: 1,
      limit: 10,
      //查询条件
      searchForm: {
        type: "",
        date: "",
        deviceCode: ""
      },
      typeSelect: [],
      push: {
        //事件通知
        formVisible: false,
        data: [],
        rePush: function (index, row) {}
      },
      handle: {
        //事件处理
        formVisible: false,
        data: {}
      },
      report: {
        //事件处理
        formVisible: false,
        state: null,
        data: {},
        submit: function () {},
        bjoptions: [
          {
            value: "1",
            label: "误报"
          },
          {
            value: "2",
            label: "真实报警"
          },
          {
            value: "3",
            label: "维保"
          },
          {
            value: "4",
            label: "测试"
          }
        ],
        gzoptions: [
          {
            value: "1",
            label: "误报"
          },
          {
            value: "2",
            label: "已维修"
          },
          {
            value: "3",
            label: "维保"
          },
          {
            value: "4",
            label: "测试"
          }
        ]
      }
    };
  },
  methods: {
    tableRowClassName: function ({ row, rowIndex }) {
      if (row.isDelete == 1) {
        return "delete";
      }
      return "";
    },
    eventDicColor: function (a) {
      return "color:" + a;
    },
    eventDictionary: function () {
      let that = this;
      EventType_API.getAllList()
        .then(
          function (result) {
            if (result && result.code == 200) {
              that.typeSelect = result.data;
            }
          },
          function (error) {
            that.$message.error({
              showClose: true,
              message: error.toString(),
              duration: 2000
            });
          }
        )
        .catch(function (error) {
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    usedFormatter: function (row, column) {
      if (row.usedState === "1") {
        return "在使用";
      } else {
        return "未使用";
      }
    },
    addressFormatter: function (row, column) {
      return (
        row.provinceName + row.cityName + row.districtName + row.addressDetail
      );
    },
    //获取项目
    getMyProject: function (query, callback) {
      let that = this;
      console.log(query);
      PROJECT_API.getMyProject({ projectName: query ? query : "" })
        .then(
          function (result) {
            if (result && result.code == 200) {
              that.projectSelects = result.data;
              if (callback) {
                callback();
              }
            }
          },
          function (error) {
            that.$message.error({
              showClose: true,
              message: error.toString(),
              duration: 2000
            });
          }
        )
        .catch(function (error) {
          that.$message.error({
            showClose: true,
            message: "请求出现异常!",
            duration: 2000
          });
        });
    },
    clearProject: function () {
      this.getMyProject();
    },
    focusProject: function () {
      if (!this.searchForm.projectId) {
        this.getMyProject();
      }
    },

    handleSizeChange: function (val) {
      this.limit = val;
      this.search();
    },
    //分页切换页码
    handleCurrentChange: function (val) {
      this.page = val;
      this.search();
    },
    //查询按钮
    handleSearch: function () {
      this.page = 1;
      this.total = 0;
      this.search();
    },
    //查询方法
    search: function () {
      let that = this;
      let params = Object.assign(
        {
          page: that.page,
          limit: that.limit
        },
        that.searchForm
      );
      params.startDate = params.date ? params.date[0] : "";
      params.endDate = params.date ? params.date[1] : "";
      params.date = undefined;
      Event_API.getList(params)
        .then(
          function (result) {
            if (result && result.code == 200) {
              that.total = result.data.total;
              that.devices = result.data.records;
            }
          },
          function (error) {
            that.$message.error({
              showClose: true,
              message: error.toString(),
              duration: 2000
            });
          }
        )
        .catch(function (error) {
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    //通知状态按钮
    showNotice: function (index, row) {
      let that = this;
      that.push.formVisible = true;
      Event_API.getPushList({ eventId: row.id })
        .then(
          function (result) {
            if (result && result.code == 200) {
              that.push.data = result.data;
            }
          },
          function (error) {
            that.$message.error({
              showClose: true,
              message: error.toString(),
              duration: 2000
            });
          }
        )
        .catch(function (error) {
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });

      //绑定推送
      that.push.rePush = function (pindex, prow) {
        //调用推送接口
        Event_API.rePush(prow.id)
          .then(
            function (result) {
              if (result && result.code == 200) {
                that.showNotice(index, row);
              }
            },
            function (error) {
              that.$message.error({
                showClose: true,
                message: error.toString(),
                duration: 2000
              });
            }
          )
          .catch(function (error) {
            that.$message.error({
              showClose: true,
              message: "请求出现异常",
              duration: 2000
            });
          });
      };
    },
    //显示处理详情
    showHandle: function (index, row) {
      let that = this;
      that.handle.formVisible = true;
      //查询数据
      Event_API.getEventDetail({ eventId: row.id })
        .then(
          function (result) {
            if (result && result.code == 200) {
              that.handle.data = result.data;
              let imgs = [];
              if (result.data.images) {
                imgs = result.data.images.split(",");
              }
              that.handle.data.images = imgs;
            }
          },
          function (error) {
            that.$message.error({
              showClose: true,
              message: error.toString(),
              duration: 2000
            });
          }
        )
        .catch(function (error) {
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    //总队处理
    reportHandle(row) {
      let that = this;
      that.report.formVisible = true;
      that.report.data = row;
      that.report.state = null;
      console.log(row);
      that.report.submit = function () {
        if (!that.report.state) {
          that.$message.error({
            showClose: true,
            message: "请选择处理状态",
            duration: 2000
          });
          return;
        }
        let param = {
          eventId: row.id,
          state: that.report.state
        };
        Event_API.reportstate(param)
          .then(
            function (result) {
              if (result && result.code == 200) {
                that.search();
                that.report.formVisible = false;
              }
            },
            function (error) {
              that.$message.error({
                showClose: true,
                message: error.toString(),
                duration: 2000
              });
            }
          )
          .catch(function (error) {
            that.$message.error({
              showClose: true,
              message: "请求出现异常",
              duration: 2000
            });
          });
      };
    },
    //修改告警状态
    updateState: function (index, row) {
      let that = this;
      if (row.sureState == 1) {
        this.$message.error({
          showClose: true,
          message: "已解除",
          duration: 2000
        });
      } else {
        this.$confirm("您确定已处理?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            //点击确定
            Event_API.updateState(row.id)
              .then(
                function (result) {
                  if (result && result.code == 200) {
                    row.eventState = 1;
                  }
                },
                function (error) {
                  that.$message.error({
                    showClose: true,
                    message: error.toString(),
                    duration: 2000
                  });
                }
              )
              .catch(function (error) {
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000
                });
              });
          })
          .catch(() => {
            //点击取消
          });
      }
    }
  },
  //页面load加载
  mounted() {
    this.eventDictionary();
    this.handleSearch();
  }
};
</script>



// WEBPACK FOOTER //
// deviceEvent.vue?e2a18876